import LocalStorageCollection from "../prototypes/LocalStorageCollection";
import PaymentModeModel, { EPaymentProviders } from "./PaymentModeModel";
//
// Collection PaymentMode
//

// @ts-ignore
class PaymentModeCollection extends LocalStorageCollection<PaymentModeModel> {
  name = "PaymentModeCollection";
  route = "apiPaymentModeCollection";
  model = PaymentModeModel;
  idAttribute = "id_payment_mode";

  initialize(
    models?: Record<string, any>[] | PaymentModeModel[],
    options?: any
  ): void {
    // ObjectCollection constructor heritage

    super.initialize.apply(this, [models, options]);
    //
  }
  getPaymentMode(id_payment_mode: any) {
    let paymentMode = null;
    this.findWhere((paymentGroup: any) => {
      paymentMode = paymentGroup.getPaymentMode(id_payment_mode);
      return !!paymentMode;
    });
    return !!paymentMode ? paymentMode : null;
  }

  getZeroPaymentMode() {
    return this.findWhere({ provider: EPaymentProviders.ZERO_PROVIDER });
  }
}

PaymentModeCollection.prototype.name = "PaymentModeCollection";
PaymentModeCollection.prototype.route = "apiPaymentModeCollection";
PaymentModeCollection.prototype.model = PaymentModeModel;
export default PaymentModeCollection;
